const prefix = 'src/redux/jobPositions/'

export const RESET_JOB_POSITION_STATE = `${prefix}reset`
export const GET_JOB_POSITION_LIST = `${prefix}list/get`
export const GET_JOB_POSITION_DETAILS = `${prefix}details/get`
export const PATCH_JOB_POSITION = `${prefix}patch`
export const PUT_JOB_POSITION = `${prefix}put`
export const POST_JOB_POSITION = `${prefix}post`
export const DELETE_JOB_POSITION = `${prefix}delete`
